module.exports = __webpack_public_path__ + "static/media/Open-Sans-regular.60d068a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Open-Sans-regular/Open-Sans-regular.svg
// module id = 417
// module chunks = 0